/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 8/25/20
 *
 */

const DocSignElementType = Object.freeze({
	SIGNATURE: 'signature',
	TEXT: 'text',
	DATE: 'date',
})

export default DocSignElementType

